<template>
  <main-layout :selectedMenu="'activity'">
    <div class="banner"></div>
    <div class="container">
      <div class="left-wrap">
        <div class="left">
          <div
            class="head"
            v-for="(item,index) in contentTab"
            :key="index"
            :class="{choose:index===contentIndex}"
            @click="changeIndex(index)"
          >{{item}}</div>
        </div>
        <div class="left-content">
          <div class="headwrap" v-for="(item,index) in 8" :key="index">
            <img src="/static/peopleCenter/headPicture.png" />
            <div class="description">
              <div class="name">Mónica Andino</div>
              <div class="profession">{{$t('global.新媒体艺术')}} / {{$t('global.创意技术')}} ...</div>
              <div class="peopleHomeWrap">
                <div class="peopleHome">{{$t('global.关注')}}</div>
                <div class="time">{{$t('global.15分钟前加组')}}</div>
              </div>
            </div>
          </div>
        </div>
        <comment></comment>
      </div>
      <competitionRight :onOff="true"></competitionRight>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import pages from "@/components/pages.vue";
import comment from "@/components/comment.vue";
import competitionRight from "@/components/competitionRight.vue";

export default {
  name: "TakePartPeople",
  metaInfo () {
      return {
        title: this.$t('global.活动报名') + " | MANA"
      }
  },
  data() {
    return {
      contentIndex: 1,
      contentTab: [
        this.$t("global.活动介绍"),
        this.$t("global.报名人员"),
        this.$t("global.活动照片"),
        this.$t("global.关于主办方")
      ]
    };
  },
  components: {
    MainLayout,
    pages,
    comment,
    competitionRight
  },
  methods: {
    changeIndex(index) {
      this.contentIndex = index;
    }
  }
};
</script>
<style lang="stylus" scoped>
.headwrap {
  display: flex;
  padding-top: 0.8rem;
  width: 6rem;

  img {
    width: 1.3rem;
    height: 1.3rem;
  }

  .description {
    /* width 1.8rem */
    margin-left: 0.3rem;
  }

  .peopleHomeWrap {
    display: flex;

    .time {
      font-size: 0.16rem;
      line-height: 0.41rem;
      color: #777777;
      margin: 0.12rem 0 0 0.21rem;
    }
  }

  .peopleHome {
    width: 1.2rem;
    height: 0.41rem;
    line-height: 0.41rem;
    margin-top: 0.12rem;
    color: #ffffff;
    text-align: center;
    text-indent: 0;
    font-size: 0.16rem;
    background-color: #0060ff;
    border-radius: 0.2rem;
  }

  .profession {
    font-size: 0.16rem;
    color: #777777;
    margin-top: 0.12rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .name {
    color: #333333;
    font-size: 0.2rem;
  }
}

.headwrap:nth-child(2n) {
  width: 3.9rem;
}

.left-content {
  display: flex;
  /* justify-content space-between */
  flex-wrap: wrap;
  width: 10.8rem;
  margin-top: 0.2rem;
  padding: 0.4rem 0.6rem;
  background-color: #ffffff;
}

.container {
  display: flex;

  .left-wrap {
    margin-top: 0.4rem;
  }
}

.left {
  display: flex;
  height: 1rem;
  width: 10.8rem;
  padding: 0 0.6rem;
  flex-wrap: nowrap;
  background-color: #ffffff;
  justify-content: space-around;

  .head {
    font-size: 0.26rem;
    line-height: 1rem;
    color: #707070;
  }
}

.choose {
  color: #333333;
  border-bottom: 2px solid #333333;
}

.banner {
  width: 100%;
  height: 6rem;
  background: url('/static/identification/Header05.png') no-repeat;
  background-size: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/onOffLineActivity/addPeople.vue